import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/api/client';
import { HandHeart, CheckCircle2, Clock, X } from 'lucide-react';
import { toast } from 'sonner';

const DEPTS = ['Media','Worship','Sunday School','VBS','Evangelism','House Keeping','Catering'];

export default function Volunteer() {
  const qc = useQueryClient();
  const { data: requests = [] } = useQuery({ queryKey: ['my-volunteer'], queryFn: async () => (await api.get('/member/volunteer-requests')).data });
  const [dept, setDept] = useState('Media');

  const mut = useMutation({
    mutationFn: async (department) => (await api.post('/member/volunteer-requests', { department })).data,
    onSuccess: () => { toast.success('Volunteer request sent for approval'); qc.invalidateQueries({ queryKey: ['my-volunteer'] }); },
    onError: (e) => toast.error(e.response?.data?.detail || 'Could not submit'),
  });

  const statusIcon = (s) => ({
    pending: <Clock size={14} className="text-moj-gold-deep"/>,
    approved: <CheckCircle2 size={14} className="text-green-700"/>,
    rejected: <X size={14} className="text-red-600"/>,
    inactive: <X size={14} className="text-gray-500"/>,
  }[s] || null);

  return (
    <div className="space-y-6">
      <div className="card-moj p-6">
        <h1 className="font-serif text-2xl text-moj-purple-deep flex items-center gap-2 mb-2"><HandHeart/> Volunteer Teams</h1>
        <p className="text-sm text-moj-charcoal/70">Choose a team to serve with. An admin or pastor will review your request, and once approved, the team leader can assign tasks to you.</p>
      </div>

      <div className="card-moj p-6">
        <h3 className="font-serif text-lg text-moj-purple-deep mb-3">Apply to a team</h3>
        <div className="flex flex-wrap gap-3 items-end">
          <div className="flex-1 min-w-[200px]">
            <label className="label-moj">Team</label>
            <select className="input-moj" value={dept} onChange={(e) => setDept(e.target.value)} data-testid="volunteer-dept">
              {DEPTS.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>
          <button onClick={() => mut.mutate(dept)} disabled={mut.isPending} className="btn-primary" data-testid="volunteer-apply"><HandHeart size={16}/> Apply to volunteer</button>
        </div>
      </div>

      <div className="card-moj p-6">
        <h3 className="font-serif text-lg text-moj-purple-deep mb-3">My Requests</h3>
        {requests.length === 0 && <p className="text-sm text-moj-charcoal/60">No volunteer requests yet.</p>}
        <div className="divide-y">
          {requests.map((r) => (
            <div key={r.id} className="flex items-center justify-between py-3">
              <div>
                <div className="font-semibold text-moj-purple-deep">{r.department}</div>
                <div className="text-xs text-moj-charcoal/60">Submitted {r.created_at?.slice(0, 10)}</div>
              </div>
              <span className="inline-flex items-center gap-1 text-xs font-bold px-3 py-1 rounded-full bg-moj-cream">{statusIcon(r.status)} {r.status.toUpperCase()}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
